import React, { useEffect, useState, memo } from 'react';
import { Check, Heart, Users, Target, Sparkles, ArrowRight, ChevronLeft, ChevronRight } from 'lucide-react';
const OfferingsPage = () => {
  const [selectedPlan, setSelectedPlan] = useState('onetime');
  const [currentSlide, setCurrentSlide] = useState(0);
  const images = ['https://uploadthingy.s3.us-west-1.amazonaws.com/4SpwaRdQ2fycsgRtD9iWy5/vfvfv.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/71LHJfrm1M3EgMaBNevw1r/vtgt.png'];
  const nextSlide = () => {
    setCurrentSlide(prev => prev === images.length - 1 ? 0 : prev + 1);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => prev === 0 ? images.length - 1 : prev - 1);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, [currentSlide]);
  const paymentPlans = [{
    id: 'onetime',
    label: 'One-Time Payment',
    price: '$400',
    detail: 'Single payment — best value',
    total: '$400 total'
  }, {
    id: 'twopay',
    label: '2 Payments',
    price: '$250',
    detail: '$250 × 2 payments',
    total: '$500 total'
  }, {
    id: 'fourpay',
    label: '4 Payments',
    price: '$130',
    detail: '$130 × 4 payments',
    total: '$520 total'
  }];
  return <div className="bg-cream" data-id="element-452">
      {/* Hero Section with Image Slider */}
      <section className="relative h-[500px] md:h-[600px] overflow-hidden" data-id="element-453">
        {/* Sliding Images */}
        {images.map((image, index) => <div key={index} className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${currentSlide === index ? 'opacity-100 z-10' : 'opacity-0 z-0'}`} data-id="element-454">
            <div className="absolute inset-0 bg-black/50 z-10" data-id="element-455"></div>
            <img src={image} alt={`Slide ${index + 1}`} className="w-full h-full object-cover" data-id="element-456" />
          </div>)}

        {/* Hero Text Content */}
        <div className="absolute inset-0 flex items-center z-20" data-id="element-457">
          <div className="container mx-auto px-4 text-center" data-id="element-458">
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-459">
              You Don't Have to Do This Alone
            </h1>
            <p className="text-xl md:text-2xl text-white/90 mb-4 max-w-3xl mx-auto" data-id="element-460">
              From pregnancy to motherhood and beyond — we're here to support,
              guide, and empower you every step of the way.
            </p>
            <p className="text-lg text-white/80 mb-8 max-w-2xl mx-auto" data-id="element-461">
              Whether you're expecting, nursing, or navigating life as a
              stay-at-home mom, you deserve a community that sees you, supports
              you, and helps you thrive.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-462">
              <a href="#jemi-moms-community" className="bg-white text-brown px-8 py-4 rounded-full hover:bg-cream transition-colors duration-300 text-center font-semibold" data-id="element-463">
                Join Jemi Moms Community
              </a>
              <a href="https://selar.com/theceomom" target="_blank" rel="noopener noreferrer" className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full hover:bg-white hover:text-brown transition-colors duration-300 text-center font-semibold" data-id="element-464">
                Explore Accountability Program
              </a>
            </div>
          </div>
        </div>

        {/* Navigation arrows */}
        <button onClick={prevSlide} className="absolute left-4 top-1/2 -translate-y-1/2 z-30 bg-white/30 hover:bg-white/50 rounded-full p-2 text-white transition-colors duration-300" aria-label="Previous slide" data-id="element-465">
          <ChevronLeft size={24} data-id="element-466" />
        </button>
        <button onClick={nextSlide} className="absolute right-4 top-1/2 -translate-y-1/2 z-30 bg-white/30 hover:bg-white/50 rounded-full p-2 text-white transition-colors duration-300" aria-label="Next slide" data-id="element-467">
          <ChevronRight size={24} data-id="element-468" />
        </button>

        {/* Dots navigation */}
        <div className="absolute bottom-6 left-0 right-0 z-30 flex justify-center gap-2" data-id="element-469">
          {images.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-3 h-3 rounded-full transition-colors duration-300 ${currentSlide === index ? 'bg-white' : 'bg-white/50'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-470" />)}
        </div>
      </section>

      {/* Who This Is For Section */}
      <section className="py-16 bg-white" data-id="element-471">
        <div className="container mx-auto px-4" data-id="element-472">
          <h2 className="text-3xl md:text-4xl font-bold text-brown mb-4 text-center" data-id="element-473">
            This Is For You If...
          </h2>
          <p className="text-gray-600 text-center mb-12 max-w-2xl mx-auto" data-id="element-474">
            You're looking for support, clarity, and community during one of
            life's most transformative seasons.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-475">
            <div className="bg-beige p-8 rounded-lg text-center" data-id="element-476">
              <div className="w-20 h-20 bg-brown/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-477">
                <Heart className="text-brown" size={32} data-id="element-478" />
              </div>
              <h3 className="text-xl font-bold text-brown mb-3" data-id="element-479">
                You're Pregnant
              </h3>
              <p className="text-gray-700" data-id="element-480">
                And you want guidance, reassurance, and a community of women who
                understand what you're going through.
              </p>
            </div>
            <div className="bg-beige p-8 rounded-lg text-center" data-id="element-481">
              <div className="w-20 h-20 bg-brown/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-482">
                <Users className="text-brown" size={32} data-id="element-483" />
              </div>
              <h3 className="text-xl font-bold text-brown mb-3" data-id="element-484">
                You're a Nursing Mom
              </h3>
              <p className="text-gray-700" data-id="element-485">
                Navigating the beautiful chaos of caring for your baby in their
                first year, and you need practical support and emotional
                encouragement.
              </p>
            </div>
            <div className="bg-beige p-8 rounded-lg text-center" data-id="element-486">
              <div className="w-20 h-20 bg-brown/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-487">
                <Target className="text-brown" size={32} data-id="element-488" />
              </div>
              <h3 className="text-xl font-bold text-brown mb-3" data-id="element-489">
                You're a Stay-at-Home Mom
              </h3>
              <p className="text-gray-700" data-id="element-490">
                Feeling stuck, lost, or unsure of your next steps — and you're
                ready to rediscover yourself and rebuild your confidence.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Jemi Moms Community Section */}
      <section id="jemi-moms-community" className="py-20 bg-cream" data-id="element-491">
        <div className="container mx-auto px-4" data-id="element-492">
          <div className="max-w-4xl mx-auto" data-id="element-493">
            <div className="text-center mb-12" data-id="element-494">
              <span className="inline-block bg-brown/10 text-brown px-4 py-2 rounded-full font-medium mb-4" data-id="element-495">
                For Pregnant Women & Nursing Moms
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-brown mb-6" data-id="element-496">
                Jemi Moms Community
              </h2>
              <p className="text-xl text-gray-700" data-id="element-497">
                A safe, supportive space where you're never alone on your
                motherhood journey.
              </p>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 mb-8" data-id="element-498">
              <h3 className="text-2xl font-bold text-brown mb-6" data-id="element-499">
                What You'll Experience:
              </h3>

              <div className="space-y-6 mb-8" data-id="element-500">
                <div className="flex items-start gap-4" data-id="element-501">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-502">
                    <Check className="text-brown" size={18} data-id="element-503" />
                  </div>
                  <div data-id="element-504">
                    <h4 className="font-bold text-brown mb-2" data-id="element-505">
                      A Community That Gets It
                    </h4>
                    <p className="text-gray-700" data-id="element-506">
                      Connect with other moms who understand the sleepless
                      nights, the feeding struggles, the overwhelming joy, and
                      the quiet fears. You're not alone anymore.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-507">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-508">
                    <Check className="text-brown" size={18} data-id="element-509" />
                  </div>
                  <div data-id="element-510">
                    <h4 className="font-bold text-brown mb-2" data-id="element-511">
                      Practical Resources & Guides
                    </h4>
                    <p className="text-gray-700" data-id="element-512">
                      Get expert-backed information on pregnancy care,
                      nutrition, postpartum recovery, and baby care from 0-12
                      months. No more endless Google searches or conflicting
                      advice.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-513">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-514">
                    <Check className="text-brown" size={18} data-id="element-515" />
                  </div>
                  <div data-id="element-516">
                    <h4 className="font-bold text-brown mb-2" data-id="element-517">
                      Regular Check-In Calls
                    </h4>
                    <p className="text-gray-700" data-id="element-518">
                      Receive emotional and mental support through regular group
                      calls where you can share, ask questions, and feel truly
                      heard.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-519">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-520">
                    <Check className="text-brown" size={18} data-id="element-521" />
                  </div>
                  <div data-id="element-522">
                    <h4 className="font-bold text-brown mb-2" data-id="element-523">
                      Trusted Recommendations
                    </h4>
                    <p className="text-gray-700" data-id="element-524">
                      Access vetted product recommendations for baby care,
                      service recommendations for antenatal care, postpartum
                      support, and baby services you can trust.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-525">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-526">
                    <Check className="text-brown" size={18} data-id="element-527" />
                  </div>
                  <div data-id="element-528">
                    <h4 className="font-bold text-brown mb-2" data-id="element-529">
                      Interactive Platforms
                    </h4>
                    <p className="text-gray-700" data-id="element-530">
                      Join WhatsApp groups, online forums, and live sessions
                      where you can connect, share experiences, and build
                      lasting friendships with other moms.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-531">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-532">
                    <Check className="text-brown" size={18} data-id="element-533" />
                  </div>
                  <div data-id="element-534">
                    <h4 className="font-bold text-brown mb-2" data-id="element-535">
                      Help Planning Special Moments
                    </h4>
                    <p className="text-gray-700" data-id="element-536">
                      Get support and ideas for your baby shower, postpartum
                      retreat, and your baby's first birthday celebration. Make
                      these moments memorable and stress-free.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-537">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-538">
                    <Check className="text-brown" size={18} data-id="element-539" />
                  </div>
                  <div data-id="element-540">
                    <h4 className="font-bold text-brown mb-2" data-id="element-541">
                      Back-to-Work Accountability
                    </h4>
                    <p className="text-gray-700" data-id="element-542">
                      For pregnant and nursing moms planning to return to work,
                      get recommendations for remote work opportunities, study
                      programs, and career growth paths that fit your new life.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-beige p-6 rounded-lg mb-8" data-id="element-543">
                <h4 className="font-bold text-brown mb-3 text-lg" data-id="element-544">
                  What This Means for You:
                </h4>
                <p className="text-gray-700 mb-4" data-id="element-545">
                  You'll feel seen, supported, informed, and confident. You'll
                  have answers when you need them, encouragement when you're
                  tired, and a community that celebrates every milestone with
                  you.
                </p>
                <p className="text-gray-700 font-medium" data-id="element-546">
                  Because motherhood is hard enough — you shouldn't have to
                  figure it out alone.
                </p>
              </div>

              <div className="text-center" data-id="element-547">
                <a href="https://selar.com/50131b4y7a" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-brown text-cream px-8 py-4 rounded-full hover:bg-brown-dark transition-colors duration-300 font-semibold text-lg" data-id="element-548">
                  Join Jemi Moms Community
                  <ArrowRight size={20} data-id="element-549" />
                </a>
                <p className="text-sm text-gray-600 mt-4" data-id="element-550">
                  Payment processed securely via Selar
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Accountability Program Section */}
      <section id="accountability-program" className="py-20 bg-white" data-id="element-551">
        <div className="container mx-auto px-4" data-id="element-552">
          <div className="max-w-4xl mx-auto" data-id="element-553">
            <div className="text-center mb-12" data-id="element-554">
              <span className="inline-block bg-brown/10 text-brown px-4 py-2 rounded-full font-medium mb-4" data-id="element-555">
                For Stay-at-Home Moms
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-brown mb-6" data-id="element-556">
                Accountability Program for Stay-at-Home Moms
              </h2>
              <p className="text-xl text-gray-700" data-id="element-557">
                Rediscover yourself. Rebuild your confidence. Take practical
                steps toward the life you want.
              </p>
            </div>

            <div className="bg-cream rounded-2xl shadow-lg p-8 md:p-12 mb-8" data-id="element-558">
              <div className="mb-8" data-id="element-559">
                <p className="text-lg text-gray-700 mb-4" data-id="element-560">
                  Being a stay-at-home mom is one of the most important roles in
                  the world — but it can also feel isolating, exhausting, and
                  sometimes... invisible.
                </p>
                <p className="text-lg text-gray-700 mb-4" data-id="element-561">
                  Maybe you've put your dreams on hold. Maybe you feel stuck,
                  unsure of who you are outside of being "mom." Maybe you're
                  wondering if it's too late to pursue your goals, grow your
                  career, or start something new.
                </p>
                <p className="text-lg text-gray-700 font-medium" data-id="element-562">
                  It's not too late. And you're not alone.
                </p>
              </div>

              <h3 className="text-2xl font-bold text-brown mb-6" data-id="element-563">
                What This Program Offers:
              </h3>

              <div className="space-y-6 mb-8" data-id="element-564">
                <div className="flex items-start gap-4" data-id="element-565">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-566">
                    <Sparkles className="text-brown" size={18} data-id="element-567" />
                  </div>
                  <div data-id="element-568">
                    <h4 className="font-bold text-brown mb-2" data-id="element-569">
                      One-on-One Clarity Sessions
                    </h4>
                    <p className="text-gray-700" data-id="element-570">
                      Get personalized guidance to help you identify your
                      strengths, clarify your goals, and create a roadmap for
                      your next chapter.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-571">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-572">
                    <Sparkles className="text-brown" size={18} data-id="element-573" />
                  </div>
                  <div data-id="element-574">
                    <h4 className="font-bold text-brown mb-2" data-id="element-575">
                      Group Accountability Sessions
                    </h4>
                    <p className="text-gray-700" data-id="element-576">
                      Join other stay-at-home moms who are also on a journey of
                      growth. Share wins, challenges, and encouragement in a
                      safe, judgment-free space.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-577">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-578">
                    <Sparkles className="text-brown" size={18} data-id="element-579" />
                  </div>
                  <div data-id="element-580">
                    <h4 className="font-bold text-brown mb-2" data-id="element-581">
                      Skill-Building & Training Sessions
                    </h4>
                    <p className="text-gray-700" data-id="element-582">
                      Learn practical skills that can help you earn income,
                      pursue a passion, or prepare for a career transition — all
                      while managing your responsibilities at home.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-583">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-584">
                    <Sparkles className="text-brown" size={18} data-id="element-585" />
                  </div>
                  <div data-id="element-586">
                    <h4 className="font-bold text-brown mb-2" data-id="element-587">
                      Remote Job & Study Recommendations
                    </h4>
                    <p className="text-gray-700" data-id="element-588">
                      Get curated opportunities for remote work, online courses,
                      certifications, and career paths that fit your lifestyle
                      and goals.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-589">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-590">
                    <Sparkles className="text-brown" size={18} data-id="element-591" />
                  </div>
                  <div data-id="element-592">
                    <h4 className="font-bold text-brown mb-2" data-id="element-593">
                      Emotional & Mindset Support
                    </h4>
                    <p className="text-gray-700" data-id="element-594">
                      Work through limiting beliefs, rebuild your confidence,
                      and develop the mindset you need to pursue your dreams
                      without guilt or fear.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-595">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-596">
                    <Sparkles className="text-brown" size={18} data-id="element-597" />
                  </div>
                  <div data-id="element-598">
                    <h4 className="font-bold text-brown mb-2" data-id="element-599">
                      Revive Your Dormant Dreams
                    </h4>
                    <p className="text-gray-700" data-id="element-600">
                      Whether it's starting a business, going back to school, or
                      simply finding more fulfillment in your daily life — we'll
                      help you take real, actionable steps forward.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 rounded-lg mb-8" data-id="element-601">
                <h4 className="font-bold text-brown mb-3 text-lg" data-id="element-602">
                  What This Means for You:
                </h4>
                <p className="text-gray-700 mb-4" data-id="element-603">
                  You'll gain clarity on who you are and what you want. You'll
                  rebuild your confidence and take practical steps toward
                  personal, career, or business growth. You'll feel empowered,
                  supported, and excited about your future again.
                </p>
                <p className="text-gray-700 font-medium" data-id="element-604">
                  Because being a mom doesn't mean you have to lose yourself.
                  You can thrive in both.
                </p>
              </div>

              {/* Pricing Section */}
              <div className="bg-brown/5 border-2 border-brown/20 p-8 rounded-lg mb-8" data-id="element-605">
                <h4 className="text-2xl font-bold text-brown mb-4 text-center" data-id="element-606">
                  Investment & Commitment
                </h4>
                <p className="text-center text-gray-600 mb-6" data-id="element-607">
                  Choose the payment option that works best for you:
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-608">
                  {paymentPlans.map(plan => <button key={plan.id} onClick={() => setSelectedPlan(plan.id)} className={`p-5 rounded-lg border-2 text-left transition-all duration-300 ${selectedPlan === plan.id ? 'border-brown bg-white shadow-md' : 'border-gray-200 bg-white/50 hover:border-brown/40'}`} data-id="element-609">
                      <div className="flex items-center gap-3 mb-3" data-id="element-610">
                        <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPlan === plan.id ? 'border-brown' : 'border-gray-300'}`} data-id="element-611">
                          {selectedPlan === plan.id && <div className="w-3 h-3 rounded-full bg-brown" data-id="element-612"></div>}
                        </div>
                        <span className="font-semibold text-brown" data-id="element-613">
                          {plan.label}
                        </span>
                      </div>
                      <p className="text-3xl font-bold text-brown mb-1" data-id="element-614">
                        {plan.price}
                      </p>
                      <p className="text-sm text-gray-600" data-id="element-615">{plan.detail}</p>
                      {plan.id === 'onetime' && <span className="inline-block mt-2 bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-medium" data-id="element-616">
                          Best Value
                        </span>}
                    </button>)}
                </div>
                <p className="text-center text-gray-600 text-sm mb-6" data-id="element-617">
                  12 months of transformation
                </p>
                <div className="space-y-3 mb-6" data-id="element-618">
                  <p className="text-gray-700 flex items-center gap-2" data-id="element-619">
                    <Check className="text-brown flex-shrink-0" size={20} data-id="element-620" />
                    <span data-id="element-621">Personalized one-on-one clarity sessions</span>
                  </p>
                  <p className="text-gray-700 flex items-center gap-2" data-id="element-622">
                    <Check className="text-brown flex-shrink-0" size={20} data-id="element-623" />
                    <span data-id="element-624">Weekly group accountability and support</span>
                  </p>
                  <p className="text-gray-700 flex items-center gap-2" data-id="element-625">
                    <Check className="text-brown flex-shrink-0" size={20} data-id="element-626" />
                    <span data-id="element-627">Skill-building workshops and training</span>
                  </p>
                  <p className="text-gray-700 flex items-center gap-2" data-id="element-628">
                    <Check className="text-brown flex-shrink-0" size={20} data-id="element-629" />
                    <span data-id="element-630">Career and remote work guidance</span>
                  </p>
                  <p className="text-gray-700 flex items-center gap-2" data-id="element-631">
                    <Check className="text-brown flex-shrink-0" size={20} data-id="element-632" />
                    <span data-id="element-633">Ongoing emotional and mindset support</span>
                  </p>
                </div>
                <p className="text-gray-700 text-center font-medium" data-id="element-634">
                  This is more than a program — it's an investment in yourself,
                  your future, and the life you deserve to live.
                </p>
              </div>

              <div className="text-center" data-id="element-635">
                <a href="https://selar.com/theceomom" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-brown text-cream px-8 py-4 rounded-full hover:bg-brown-dark transition-colors duration-300 font-semibold text-lg" data-id="element-636">
                  Apply for Accountability Program
                  <ArrowRight size={20} data-id="element-637" />
                </a>
                <p className="text-sm text-gray-600 mt-4" data-id="element-638">
                  Payment processed securely via Selar
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Transformation Section */}
      <section className="py-20 bg-beige" data-id="element-639">
        <div className="container mx-auto px-4" data-id="element-640">
          <div className="max-w-4xl mx-auto text-center" data-id="element-641">
            <h2 className="text-3xl md:text-4xl font-bold text-brown mb-6" data-id="element-642">
              The Transformation You Deserve
            </h2>
            <p className="text-xl text-gray-700 mb-12" data-id="element-643">
              Whether you join our community or our accountability program,
              here's what you can expect:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-644">
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-645">
                <h3 className="text-xl font-bold text-brown mb-3" data-id="element-646">
                  Emotional Relief
                </h3>
                <p className="text-gray-700" data-id="element-647">
                  No more feeling alone, overwhelmed, or unsure. You'll have a
                  community and support system that truly understands.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-648">
                <h3 className="text-xl font-bold text-brown mb-3" data-id="element-649">
                  Confidence
                </h3>
                <p className="text-gray-700" data-id="element-650">
                  You'll feel empowered to make decisions, pursue your goals,
                  and trust yourself as a mother and as a woman.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-651">
                <h3 className="text-xl font-bold text-brown mb-3" data-id="element-652">Direction</h3>
                <p className="text-gray-700" data-id="element-653">
                  Clear, practical steps forward — whether it's caring for your
                  baby, planning your next career move, or rediscovering your
                  purpose.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-654">
                <h3 className="text-xl font-bold text-brown mb-3" data-id="element-655">Growth</h3>
                <p className="text-gray-700" data-id="element-656">
                  Personal, professional, and emotional growth that helps you
                  become the best version of yourself — for you and your family.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-20 bg-brown text-white" data-id="element-657">
        <div className="container mx-auto px-4 text-center" data-id="element-658">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-659">
            Ready to Take the Next Step?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto" data-id="element-660">
            You don't have to navigate motherhood alone. Join a community that
            sees you, supports you, and helps you thrive.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-661">
            <a href="https://selar.com/50131b4y7a" target="_blank" rel="noopener noreferrer" className="bg-white text-brown px-8 py-4 rounded-full hover:bg-cream transition-colors duration-300 font-semibold" data-id="element-662">
              Join Jemi Moms Community
            </a>
            <a href="https://selar.com/theceomom" target="_blank" rel="noopener noreferrer" className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full hover:bg-white hover:text-brown transition-colors duration-300 font-semibold" data-id="element-663">
              Apply for Accountability Program
            </a>
          </div>
          <p className="mt-8 text-cream/90" data-id="element-664">
            Because raising a child — and raising yourself — takes more than
            love. It takes a community. 💕
          </p>
        </div>
      </section>
    </div>;
};
export default OfferingsPage;